export default __webpack_public_path__ + "static/media/default_avatar.24018b26.png";